import axios from 'axios';
import { logoutAndRedirect } from '../utils/authSession';

const trimTrailingSlash = (value = '') => String(value || '').replace(/\/+$/, '');

const detectAppOrigin = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return trimTrailingSlash(window.location.origin);
  }
  return 'https://on-labs.eu';
};

const APP_ORIGIN = trimTrailingSlash(process.env.REACT_APP_APP_ORIGIN || detectAppOrigin());
const API_ORIGIN = trimTrailingSlash(process.env.REACT_APP_API_ORIGIN || APP_ORIGIN);
const STATS_ORIGIN = trimTrailingSlash(process.env.REACT_APP_STATS_ORIGIN || APP_ORIGIN);

const attachAuthInterceptors = (client) => {
  client.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (!token) {
        return config;
      }

      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const requestUrl = String(error?.config?.url || '');
      const skipAuthLogout = Boolean(error?.config?.skipAuthLogout);
      const hasStoredToken = Boolean(localStorage.getItem('token'));
      const isPublicAuthRoute =
        requestUrl.includes('/auth/login') ||
        requestUrl.includes('/auth/register') ||
        requestUrl.includes('/auth/invitations/');

      if (status === 401 && hasStoredToken && !skipAuthLogout && !isPublicAuthRoute) {
        logoutAndRedirect({ message: 'Your session expired. Please sign in again.' });
      }

      return Promise.reject(error);
    }
  );
};

// Основен API клиент за on-labs.eu
export const apiClient = axios.create({
  baseURL: `${API_ORIGIN}/api`,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});
// 🔵 Нов API клиент за apiNew (кампанийни импорти и др.)
export const apiNewClient = axios.create({
  baseURL: `${API_ORIGIN}/apiNew`,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});
// API клиент за статистиката на устройствата (localhost:3004)
export const deviceApiClient = axios.create({
  baseURL: `${STATS_ORIGIN}/stats`,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});

attachAuthInterceptors(apiClient);
attachAuthInterceptors(apiNewClient);
attachAuthInterceptors(deviceApiClient);
